import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=0a7956c8&scoped=true&lang=html&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7956c8",
  null
  
)

export default component.exports